export function isLazyLoad(options: { lazyLoad?: boolean }): boolean {
  return !options || !(options.lazyLoad === false);
}
